const setAddRatingStatus = (state, status) => {
  state.addRatingStatus = status;
};

const setInspectors = (state, inspectors) => {
  state.inspectors = inspectors;
};

const setRating = (state, rating) => {
  state.rating = rating;
};

export default {
  setInspectors,
  setAddRatingStatus,
  setRating,
};
